import { CampaignNav } from '@/ui'
import { CampaignOverviewViewModel } from '@/ui'
import { useState } from 'react'
import { RequireAccess } from '../../../../components'
import { InvoicePanel } from './invoice-panel'
import { PreviewMode, PreviewPanel } from './preview-panel'
import { SettingsPanel } from './settings-panel'
import { TimelinePanel } from './timeline-panel'

export function CampaignOverview({ view, loading, renderers }: CampaignOverviewViewModel) {
	const [previewMode, setPreviewMode] = useState<PreviewMode>('feed')

	const handlePreviousPreview = () => {
		setPreviewMode(previewMode === 'feed' ? 'story' : 'feed')
	}

	const handleNextPreview = () => {
		setPreviewMode(previewMode === 'feed' ? 'story' : 'feed')
	}

	return (
		<CampaignNav activeCampaignNavLink="overview">
			<div className="min-h-[var(--screen-height)]">
				<div className="grid grid-cols-[auto_1px_1fr] gap-12">
					{/* Left Side - Sticky Preview */}
					<div className="py-10 sticky top-[calc(var(--main-nav-height)+var(--campaign-nav-height)+40px)] self-start">
						<PreviewPanel
							previewMode={previewMode}
							onPrevious={handlePreviousPreview}
							onNext={handleNextPreview}
							campaign={view.campaign}
							feedAd={view.feedAd}
							storyAd={view.storyAd}
							formPreviewLinkRenderer={renderers.formPreviewLink}
							formEditorLinkRenderer={renderers.formEditorLink}
							reachOverride={view.reachOverride}
							isLoading={loading.campaign}
						/>
					</div>

					<div className="h-full w-full bg-grey-200" />

					{/* Right Side - Campaign Settings */}
					<div className="py-10 space-y-8">
						<RequireAccess permission="invoice:view">
							<InvoicePanel
								invoice={view.invoice}
								isLoading={loading.invoice || loading.campaign}
								payments={view.payments}
							/>
						</RequireAccess>
						<SettingsPanel
							campaign={view.campaign}
							reachOverride={view.reachOverride}
							isLoading={loading.campaign}
							careerSite={view.careerSite}
						/>
						<TimelinePanel campaign={view.campaign} isLoading={loading.campaign} />
					</div>
				</div>
			</div>
		</CampaignNav>
	)
}
